import { LOGO_LOADER_MAP } from '../shared/Constants/theme.constants';

function useLogoLoader(type) {
  return {
    logo: LOGO_LOADER_MAP?.[type]?.logo,
    loader: LOGO_LOADER_MAP?.[type]?.loader,
    type: LOGO_LOADER_MAP?.[type]?.type,
  };
}

export default useLogoLoader;
